<template>
  <v-app class="tw-bg-gray-100">
    <traditional-header @drawer="drawerHandle" />
    <traditional-navigation v-if="$vuetify.breakpoint.mdAndUp" />
    <v-main class="tw-min-h-screen">
      <slot>
        <v-fade-transition>
          <router-view/>
        </v-fade-transition>
      </slot>
    </v-main>
    <default-footer />
    <default-drawer :visible.sync="visible.drawer" />
  </v-app>
</template>
<script>
import DefaultDrawer from '../components/layouts/DefaultDrawer'
import DefaultFooter from '@/components/layouts/DefaultFooter'
import TraditionalHeader from '@/components/layouts/TraditionalHeader'
import TraditionalNavigation from '@/components/layouts/TraditionalHeaderNavigation'
export default {
  name: 'CardLayout',
  components: { TraditionalNavigation, TraditionalHeader, DefaultFooter, DefaultDrawer },
  data () {
    return {
      visible: {
        drawer: false
      }
    }
  },
  methods: {
    drawerHandle () {
      this.visible.drawer = !this.visible.drawer
    }
  }
}
</script>
